import * as BTConstant from '../../../utils/bt-constant'
const parse = require('../../../braintree/lib/docs-url-parser')();
export const findBTLeftNav = (obj, pathname) => {
  const keys = Object.keys(obj)    
  const splitKey = pathname.includes(BTConstant.DOC_PREFIX) ? BTConstant.DOC_PREFIX : BTConstant.ARTICLES_PREFIX
  const check = pathname.split(splitKey)[1].split('/')[1]  
  for(let i=0; i<keys.length; i++) {
    if(check === 'reference' ){
      let ref_param = pathname.split('/')[3]
      if(ref_param ==='client-api'){
        return obj['client-api']
      }
      else if(ref_param === 'xml-api'){
        return obj['xml-api']
      }
      else if(keys[i] === check){
        return obj[keys[i]]
      }
    }
    else if(keys[i] === check) {
      return obj[keys[i]]
    }
  }
}

const hasClass = (element, classname) => {
  if(element && classname) return Array.from(element.classList).includes(classname)
  return false
}

const addClass = (element, classname) => {
  element.classList.add(classname)
  return element
}

const removeClass = (element, classname) => {
  element.classList.remove(classname)
  return element
}

const unselectActiveNav = () => {
  const activeElement = document.querySelector('.sidebar a.is-active');
  if(!activeElement) return 
  if(hasClass(activeElement, 'is-active')) removeClass(activeElement, 'is-active')
  let parent = activeElement.parentElement
  while(parent && parent.classList.value !== 'menu') {
    if(hasClass(parent, 'menu-tertiary')) removeClass(parent, 'is-open')
    parent = parent.parentElement
  }
}

const selectActiveNav = (_pathname) => {
  let pathname = _pathname.substr(-1) === '/' ? _pathname.slice(0, -1) : _pathname
  let pathObject = parse(pathname)
  pathname = pathObject && pathObject.contentPath ? pathObject.contentPath : pathname // if path contains language and /or version
  const anchor = document.querySelector(`.sidebar a[href='${pathname}']`)
  if(!anchor) {
    console.log("9908Error: No Active nav found", pathname)
    return
  }
  unselectActiveNav()
  if(!hasClass(anchor, 'is-active')) addClass(anchor, 'is-active')
  let parent = anchor.parentElement
  while(parent && parent.classList.value !== 'menu') {
    if(hasClass(parent, 'menu-tertiary')) addClass(parent, 'is-open')
    if(hasClass(parent.firstElementChild, 'has-menu')) addClass(parent, 'is-open')
    if( hasClass(parent,"menu__item") ) parent.scrollIntoView()
    parent = parent.parentElement
  }
}

function selectFirstMenuChild (event) {
  event.target.parentNode.querySelectorAll('.menu-secondary__link')[0].click()
}
function selectFirstSecMenuChild (event) {
  event.target.parentNode.querySelectorAll('.menu-tertiary__link')[0].click()
}

export const initLeftNav = (pathname) => {
  document.querySelectorAll('.menu__link.has-menu').forEach(menu => {
    menu.addEventListener('click', selectFirstMenuChild)
  })
  document.querySelectorAll('.menu-secondary__link.has-menu').forEach(menuSecondary => {
    menuSecondary.addEventListener('click', selectFirstSecMenuChild)
  })
 selectActiveNav(pathname)
}

export const clearLeftNav = () => {
  document.querySelectorAll('.menu__link.has-menu').forEach(menu => {
    menu.removeEventListener('click', selectFirstMenuChild)
  })
  document.querySelectorAll('.menu-secondary__link.has-menu').forEach(menuSecondary => {
    menuSecondary.removeEventListener('click', selectFirstSecMenuChild)
  })
}

function onScroll(event){
  const element = document.querySelector('.flex.app')
  const scrollTop = event.target.scrollTop;    
    if(scrollTop < 100 ) {  
       removeClass(element, 'app--collapsed')
    } else {
      !hasClass(element, 'app--collapsed')  && addClass(element, 'app--collapsed') 
    }
}

export const initProductLayout = (config) => {
  let elm = document.querySelector('.flex-sidebar')
  elm  && (elm.style.flex = `0 0 ${config.left.width}`)
  document.querySelector('.flex-content').style.flex = `1 1 ${config.right.width}`
  document.querySelector('html').style.lineHeight = 1.875
  document.querySelector('body').style.fontSize = "1.125rem"
  document.querySelector('.flex-content').addEventListener('scroll', onScroll)
}

export const clearProductLayout = () => {

  document.querySelector('html').style.lineHeight = 1.25
  document.querySelector('body').style.fontSize = "unset"
  document.querySelector('.flex-content').removeEventListener('scroll', onScroll)
}



